// extracted by css-extract-rspack-plugin
export default {"formControlLabel":"formControlLabel-N9f_DI","label":"label-h6jmtU"};